import React from "react";

import "./Icon.scss";

export type CSVIconProps = {
  cx?: string;
};

export const CSVIcon: React.FC<CSVIconProps> = ({ cx = "" }) => {
  return (
    <svg
      width="152"
      height="138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`CSVIcon ${cx}`}
    >
      <g className={"back-card"}>
        <g filter="url(#a)">
          <path
            fill="#000"
            fillOpacity=".13"
            d="m27.578 55.574 39.318-10.59 10.647 39.945-39.317 10.59z"
          />
        </g>
        <g filter="url(#b)">
          <rect
            width="65.478"
            height="78.93"
            rx="5"
            transform="rotate(-15.075 113.009 -68.674) skewX(-.15)"
            fill="#fff"
          />
        </g>
        <mask
          id="c"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="32"
          y="20"
          width="56"
          height="48"
        >
          <rect
            width="49.763"
            height="36.834"
            rx="5"
            transform="rotate(-15.075 138.914 -102.254) skewX(-.15)"
            fill="#219E63"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill="#32BF7E"
            d="m31.371 32.61 24.026-6.471 2.371 8.897-24.025 6.472z"
          />
          <path
            fill="#219F64"
            d="m33.75 41.508 24.026-6.472 2.371 8.898-24.025 6.471z"
          />
          <path
            fill="#20985F"
            d="m55.41 26.139 24.026-6.472 2.372 8.898-24.026 6.471z"
          />
          <path
            fill="#10713C"
            d="M57.773 35.037 81.8 28.566l2.372 8.897-24.026 6.471z"
          />
          <path
            fill="#10743E"
            d="m36.117 50.407 24.026-6.471 2.372 8.897-24.026 6.472z"
          />
          <path
            fill="#185634"
            d="m38.488 59.305 24.026-6.472 2.372 8.898-24.026 6.471z"
          />
          <path
            fill="#195D38"
            d="m60.156 43.935 24.026-6.472 2.372 8.898-24.026 6.47z"
          />
          <path
            fill="#185734"
            d="M62.516 52.831 86.54 46.36l2.372 8.897-24.026 6.471z"
          />
        </g>
      </g>
      <g className={"front-card"}>
        <g filter="url(#d)">
          <path
            fill="#000"
            fillOpacity=".11"
            d="m32.246 38.6 39.318-10.59L89.154 94l-39.318 10.59z"
          />
        </g>
        <g filter="url(#e)">
          <rect
            width="65.466"
            height="78.945"
            rx="5"
            transform="rotate(10.197 -39.682 345.165) skewX(.104)"
            fill="#fff"
          />
        </g>
        <mask
          id="f"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="61"
          y="22"
          width="54"
          height="44"
        >
          <rect
            width="49.754"
            height="36.841"
            rx="5"
            transform="rotate(10.197 -87.858 385.318) skewX(.104)"
            fill="#219E63"
          />
        </mask>
        <g mask="url(#f)">
          <path
            fill="#32BF7E"
            d="m66.828 21.64 24.484 4.405-1.614 9.067-24.484-4.404z"
          />
          <path
            fill="#219F64"
            d="m65.219 30.708 24.484 4.404-1.614 9.068-24.484-4.405z"
          />
          <path
            fill="#20985F"
            d="m91.316 26.044 24.484 4.404-1.614 9.068-24.484-4.405z"
          />
          <path
            fill="#10713C"
            d="m89.703 35.112 24.484 4.404-1.614 9.068-24.484-4.404z"
          />
          <path
            fill="#10743E"
            d="m63.602 39.776 24.484 4.405-1.614 9.067-24.484-4.404z"
          />
          <path
            fill="#185634"
            d="m61.98 48.845 24.485 4.404-1.615 9.067-24.484-4.404z"
          />
          <path
            fill="#195D38"
            d="m88.082 44.18 24.484 4.404-1.614 9.067-24.484-4.404z"
          />
          <path
            fill="#185734"
            d="m86.473 53.248 24.484 4.404-1.614 9.068-24.484-4.405z"
          />
        </g>
        <path
          d="M83.03 41.728c.19-2.207-1.18-3.728-3.37-4.122-2.367-.426-4.51.837-5.035 3.782-.522 2.931 1.004 4.868 3.418 5.302 2.53.455 4.157-1.066 4.56-2.562l-2.347-.435c-.267.754-.911 1.137-1.805.976-1.19-.214-1.742-1.191-1.447-2.853.282-1.58 1.135-2.39 2.359-2.17.932.168 1.388.82 1.318 1.66l2.35.422zM91.195 42.626c.297-1.715-.828-3.094-2.936-3.473-2.066-.372-3.735.486-4.02 2.164-.248 1.368.56 2.302 2.05 2.922l.854.358c.936.392 1.253.707 1.185 1.136-.091.465-.574.712-1.36.57-.924-.165-1.41-.698-1.306-1.526l-2.204-.397c-.37 2.18.927 3.437 3.199 3.846 2.22.4 3.717-.338 4.033-2.064.234-1.366-.443-2.441-2.251-3.19l-.706-.291c-.79-.325-1.157-.65-1.055-1.1.078-.413.475-.653 1.24-.516.79.142 1.115.562 1.06 1.162l2.217.4zM92.43 40.028l1.347 9.367 3.148.567 4.495-8.317-2.611-.47-2.97 5.971-.072-.013-.725-6.635-2.611-.47z"
          fill="#fff"
        />
      </g>

      <g className={"plus"}>
        <g filter="url(#g)">
          <ellipse
            cx="100.803"
            cy="87.169"
            rx="23.752"
            ry="23.565"
            fill="#000"
            fillOpacity=".07"
          />
        </g>
        <g filter="url(#h)">
          <ellipse
            cx="106.931"
            cy="82.806"
            rx="23.286"
            ry="23.565"
            fill="#fff"
          />
        </g>
        <path
          d="M108.214 91.001v-6.88H115v-1.24h-6.786v-6.88h-1.428v6.88H100v1.24h6.786V91h1.428z"
          fill="#000"
        />
      </g>

      <defs>
        <filter
          id="a"
          x=".395"
          y="17.802"
          width="104.331"
          height="104.902"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation="13.591"
            result="effect1_foregroundBlur"
          />
        </filter>
        <filter
          id="b"
          x="16.867"
          y="10.126"
          width="93.319"
          height="103.042"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.228403 0 0 0 0 0.271783 0 0 0 0 0.383333 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="d"
          x="5.063"
          y=".827"
          width="111.273"
          height="130.947"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation="13.591"
            result="effect1_foregroundBlur"
          />
        </filter>
        <filter
          id="e"
          x="41.441"
          y="12.283"
          width="88.671"
          height="99.702"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.228403 0 0 0 0 0.271783 0 0 0 0 0.383333 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="g"
          x="49.868"
          y="36.422"
          width="101.87"
          height="101.495"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation="13.591"
            result="effect1_foregroundBlur"
          />
        </filter>
        <filter
          id="h"
          x="77.644"
          y="58.241"
          width="58.573"
          height="59.13"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.228403 0 0 0 0 0.271783 0 0 0 0 0.383333 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
